export class GcpFreeProtectionBilling {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "orderId",
            "baseName": "orderId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpFreeProtectionBilling.attributeTypeMap;
    }
    constructor() {
    }
}
